import LayoutBlank from '@/layout/LayoutBlank'

export default [{
  path: '/share',
  component: LayoutBlank,
  children: [
  ]
}]
